<div *ngIf="entry">
    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">{{ entry.name }}</div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">Details</div>
            <div class="card-text">
                <span *ngIf="entry.start"><strong>Start: </strong></span>{{ entry.start?.toDate() | date:'yyyy/MM/dd h:mm:ss a' }}
                <span *ngIf="entry.finish"><strong>Finish: </strong></span>{{ entry.finish?.toDate() | date:'yyyy/MM/dd h:mm:ss a' }}
                <span *ngIf="entry.time()"><strong>Time: </strong></span>{{ entry.time() }}
            </div>
        </div>
    </div>
</div>